function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import t from "@swup/plugin";
var s = /*#__PURE__*/function () {
  function s() {
    var _this = this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      t = _ref.className,
      _s = _ref.styleAttr,
      e = _ref.animationDuration,
      i = _ref.minValue,
      r = _ref.initialValue,
      a = _ref.trickleValue;
    _classCallCheck(this, s);
    this.value = 0, this.visible = !1, this.hiding = !1, this.className = "progress-bar", this.styleAttr = "data-progressbar-styles data-swup-theme", this.animationDuration = 300, this.minValue = .1, this.initialValue = .25, this.trickleValue = .03, this.trickleInterval = void 0, this.styleElement = void 0, this.progressElement = void 0, this.trickle = function () {
      var t = Math.random() * _this.trickleValue;
      _this.setValue(_this.value + t);
    }, void 0 !== t && (this.className = String(t)), void 0 !== _s && (this.styleAttr = String(_s)), void 0 !== e && (this.animationDuration = Number(e)), void 0 !== i && (this.minValue = Number(i)), void 0 !== r && (this.initialValue = Number(r)), void 0 !== a && (this.trickleValue = Number(a)), this.styleElement = this.createStyleElement(), this.progressElement = this.createProgressElement();
  }
  _createClass(s, [{
    key: "defaultStyles",
    get: function get() {
      return "\n\t\t.".concat(this.className, " {\n\t\t\tposition: fixed;\n\t\t\tdisplay: block;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n      width: 100%;\n\t\t\theight: 3px;\n\t\t\tbackground-color: black;\n\t\t\tz-index: 9999;\n\t\t\ttransition:\n\t\t\t\ttransform ").concat(this.animationDuration, "ms ease-out,\n\t\t\t\topacity ").concat(this.animationDuration / 2, "ms ").concat(this.animationDuration / 2, "ms ease-in;\n\t  transform: translate3d(0, 0, 0) scaleX(var(--progress, 0));\n      transform-origin: 0;\n\t\t}\n\t");
    }
  }, {
    key: "show",
    value: function show() {
      this.visible || (this.visible = !0, this.installStyleElement(), this.installProgressElement(), this.startTrickling());
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this2 = this;
      this.visible && !this.hiding && (this.hiding = !0, this.fadeProgressElement(function () {
        _this2.uninstallProgressElement(), _this2.stopTrickling(), _this2.visible = !1, _this2.hiding = !1;
      }));
    }
  }, {
    key: "setValue",
    value: function setValue(t) {
      this.value = Math.min(1, Math.max(this.minValue, t)), this.refresh();
    }
  }, {
    key: "installStyleElement",
    value: function installStyleElement() {
      document.head.prepend(this.styleElement);
    }
  }, {
    key: "installProgressElement",
    value: function installProgressElement() {
      this.progressElement.style.setProperty("--progress", String(0)), this.progressElement.style.opacity = "1", document.body.prepend(this.progressElement), this.progressElement.scrollTop = 0, this.setValue(Math.random() * this.initialValue);
    }
  }, {
    key: "fadeProgressElement",
    value: function fadeProgressElement(t) {
      this.progressElement.style.opacity = "0", setTimeout(t, 1.5 * this.animationDuration);
    }
  }, {
    key: "uninstallProgressElement",
    value: function uninstallProgressElement() {
      this.progressElement.remove();
    }
  }, {
    key: "startTrickling",
    value: function startTrickling() {
      this.trickleInterval || (this.trickleInterval = window.setInterval(this.trickle, this.animationDuration));
    }
  }, {
    key: "stopTrickling",
    value: function stopTrickling() {
      window.clearInterval(this.trickleInterval), delete this.trickleInterval;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this3 = this;
      requestAnimationFrame(function () {
        _this3.progressElement.style.setProperty("--progress", String(_this3.value));
      });
    }
  }, {
    key: "createStyleElement",
    value: function createStyleElement() {
      var t = document.createElement("style");
      return this.styleAttr.split(" ").forEach(function (_s2) {
        return t.setAttribute(_s2, "");
      }), t.textContent = this.defaultStyles, t;
    }
  }, {
    key: "createProgressElement",
    value: function createProgressElement() {
      var t = document.createElement("div");
      return t.className = this.className, t.setAttribute("aria-hidden", "true"), t;
    }
  }]);
  return s;
}();
var e = /*#__PURE__*/function (_t) {
  _inherits(e, _t);
  var _super = _createSuper(e);
  function e() {
    var _this4;
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, e);
    _this4 = _super.call(this), _this4.name = "SwupProgressPlugin", _this4.defaults = {
      className: "swup-progress-bar",
      delay: 300,
      transition: 300,
      minValue: .1,
      initialValue: .25,
      finishAnimation: !0
    }, _this4.options = void 0, _this4.progressBar = void 0, _this4.showProgressBarTimeout = void 0, _this4.hideProgressBarTimeout = void 0, _this4.options = _objectSpread(_objectSpread({}, _this4.defaults), t);
    var _this4$options = _this4.options,
      _e = _this4$options.className,
      i = _this4$options.minValue,
      r = _this4$options.initialValue,
      a = _this4$options.transition;
    _this4.progressBar = new s({
      className: _e,
      minValue: i,
      initialValue: r,
      animationDuration: a
    });
    return _this4;
  }
  _createClass(e, [{
    key: "mount",
    value: function mount() {
      this.on("visit:start", this.startShowingProgress), this.on("page:view", this.stopShowingProgress);
    }
  }, {
    key: "startShowingProgress",
    value: function startShowingProgress() {
      this.progressBar.setValue(0), this.showProgressBarAfterDelay();
    }
  }, {
    key: "stopShowingProgress",
    value: function stopShowingProgress() {
      this.progressBar.setValue(1), this.options.finishAnimation ? this.finishAnimationAndHideProgressBar() : this.hideProgressBar();
    }
  }, {
    key: "showProgressBar",
    value: function showProgressBar() {
      this.cancelHideProgressBarTimeout(), this.progressBar.show();
    }
  }, {
    key: "showProgressBarAfterDelay",
    value: function showProgressBarAfterDelay() {
      this.cancelShowProgressBarTimeout(), this.cancelHideProgressBarTimeout(), this.showProgressBarTimeout = window.setTimeout(this.showProgressBar.bind(this), this.options.delay);
    }
  }, {
    key: "hideProgressBar",
    value: function hideProgressBar() {
      this.cancelShowProgressBarTimeout(), this.progressBar.hide();
    }
  }, {
    key: "finishAnimationAndHideProgressBar",
    value: function finishAnimationAndHideProgressBar() {
      this.cancelShowProgressBarTimeout(), this.hideProgressBarTimeout = window.setTimeout(this.hideProgressBar.bind(this), this.options.transition);
    }
  }, {
    key: "cancelShowProgressBarTimeout",
    value: function cancelShowProgressBarTimeout() {
      window.clearTimeout(this.showProgressBarTimeout), delete this.showProgressBarTimeout;
    }
  }, {
    key: "cancelHideProgressBarTimeout",
    value: function cancelHideProgressBarTimeout() {
      window.clearTimeout(this.hideProgressBarTimeout), delete this.hideProgressBarTimeout;
    }
  }]);
  return e;
}(t);
export { e as default };